import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ersConstants } from '@rcs/utils';
import { ErsIdentityService } from './services/ers-identity/ers-identity.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ers-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly _identityService = inject(ErsIdentityService);
  private readonly _router = inject(Router);

  title = 'ers';

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  @HostListener('window:storage', ['$event'])
  onStorageChanged(event: StorageEvent): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const isJwtRemoved =
      event.key === ersConstants.ERS_JWT_TOKEN && event.newValue === null;
    const isStorageCleared = event.key === null && event.oldValue !== null;

    if (isJwtRemoved || isStorageCleared) {
      this._identityService.logOutRequest();
      this._router.navigateByUrl('/login');
    }
  }
}
